import React from "react";
import { Download } from "components/core/BaseTable/styles";
import DownloadIcon from "assets/images/downloadcsv.png"
import { Ptag } from "components/core/fonts";
import http from "services/httpService"

const ClaimMisDownload = () => {

  const downloadClaimsData = async () => {
    const { data } = await http.post(
      "business/download_mis_claims_data/",
      {},
      { responseType: "blob" }
    );
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(new Blob([data]));
    link.download = "employee_claims_data.xlsx";

    // Append link to the DOM and click it
    document.body.appendChild(link);
    link.click();

    // Clean up
    document.body.removeChild(link);
    window.URL.revokeObjectURL(link.href);
  };

  return (
    <>
      <Download
        onClick={downloadClaimsData}
        style={{
          width: "320px",
          whiteSpace: "nowrap",
          marginRight: "0px"
        }}
      >
        <img
          src={DownloadIcon}
          width="18px"
          height="18px"
          style={{ marginRight: 8 }}
        />
        <Ptag
          fontSize="14px"
          fontWeight="600"
          color="#FFFFFF"
          lineHeight="24px"
          letterSpacing="0.5px"
        >
          Download Complete Data
        </Ptag>
      </Download>
    </>
  );
};

export default ClaimMisDownload;
